import LanguageSwitcher from "./LanguageSwitcher";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="relative z-40 border-b border-[rgba(22,99,230,0.12)] bg-white/95 backdrop-blur"
    >
      <div className="mx-auto flex h-[60px] w-full max-w-[480px] items-center justify-between px-5">
        <div className="flex items-center gap-2.5" data-testid="site-brand">
          <span className="font-display flex h-9 w-9 items-center justify-center rounded-xl bg-[#1663E6] text-[13px] font-bold tracking-wide text-white">
            ASG
          </span>
          <span className="leading-tight">
            <span className="block text-sm font-bold text-[#0B3D91]">ASG</span>
            <span className="block text-[10px] font-medium tracking-wide text-slate-500">
              Asia Sports Guide
            </span>
          </span>
        </div>
        <LanguageSwitcher inline />
      </div>
    </header>
  );
}
